import React from 'react';
import type { LegendEntry } from '../types';

interface GraphLegendProps {
  legend?: LegendEntry[];
  sidebarOpen?: boolean;
}

const GraphLegend: React.FC<GraphLegendProps> = ({ legend, sidebarOpen }) => {
  if (!legend || legend.length === 0) return null;

  return (
    <div style={{
      position: 'absolute',
      bottom: 16,
      left: sidebarOpen ? 360 : 0,
      transition: 'left 0.3s ease',
      padding: '8px 12px',
      fontSize: 12,
      lineHeight: '20px',
      color: '#929292',
      zIndex: 10,
      pointerEvents: 'none',
    }}>
      {legend.map((entry) => (
        <div key={entry.name} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: entry.color,
            flexShrink: 0,
          }} />
          <span>{entry.name}</span>
        </div>
      ))}
    </div>
  );
};

export default GraphLegend;
